import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LOGO } from "@/lib/brand";

const ROWS = [
  ["Necessari", "Cookie di sessione, protezione CSRF, preferenze cookie (leadders_cookie_consent).", "Sessione / 12 mesi", "Non richiesto (interesse legittimo)"],
  ["Statistici", "Misurazione anonima delle visite e dell'uso delle pagine. Attivi solo dopo il consenso.", "Fino a 13 mesi", "Consenso"],
  ["Marketing", "Misurazione delle campagne pubblicitarie da cui provieni. Attivi solo dopo il consenso.", "Fino a 13 mesi", "Consenso"],
];

export default function CookiePolicy() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border">
        <div className="max-w-4xl mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/"><img src={LOGO} alt="Leadders" className="h-9 w-auto" /></Link>
          <Button asChild variant="ghost" size="sm"><Link to="/">Torna al sito</Link></Button>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 py-12 space-y-8 text-primary" data-testid="cookie-policy-page">
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight">Cookie Policy</h1>
        <p className="text-muted-foreground leading-relaxed">
          Questa informativa descrive i cookie utilizzati dai siti gestiti da Leadders (incluse le pagine di raccolta richieste collegate),
          ai sensi del Regolamento UE 2016/679 (GDPR), del D.Lgs. 196/2003 e delle Linee guida del Garante Privacy del 10 giugno 2021.
        </p>
        <section className="space-y-3">
          <h2 className="font-display text-base md:text-lg font-bold">Cosa sono i cookie</h2>
          <p className="text-sm leading-relaxed">Piccoli file di testo salvati sul tuo dispositivo che permettono al sito di funzionare, ricordare le tue scelte e misurare le visite.</p>
        </section>
        <section className="space-y-3">
          <h2 className="font-display text-base md:text-lg font-bold">Cookie utilizzati</h2>
          <div className="overflow-x-auto rounded-xl border border-border">
            <table className="w-full text-sm">
              <thead className="bg-secondary text-left">
                <tr>{["Categoria", "Finalità", "Durata", "Base giuridica"].map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}</tr>
              </thead>
              <tbody>
                {ROWS.map((r) => (
                  <tr key={r[0]} className="border-t border-border">{r.map((c, i) => <td key={i} className="px-4 py-3 align-top">{c}</td>)}</tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
        <section className="space-y-3">
          <h2 className="font-display text-base md:text-lg font-bold">Come gestire le preferenze</h2>
          <p className="text-sm leading-relaxed">
            Puoi modificare o revocare il consenso in qualsiasi momento dal pulsante qui sotto o dalle impostazioni del browser.
            Il rifiuto dei cookie non necessari non limita la navigazione né la verifica di fattibilità.
          </p>
          <Button data-testid="cookie-reopen-button" variant="outline" onClick={() => window.dispatchEvent(new Event("open-cookie-settings"))}>
            Gestisci preferenze cookie
          </Button>
        </section>
        <section className="space-y-3">
          <h2 className="font-display text-base md:text-lg font-bold">Titolare del trattamento</h2>
          <p className="text-sm leading-relaxed">Leadders. Per esercitare i diritti previsti dagli artt. 15-22 GDPR puoi scrivere ai contatti indicati nel sito.</p>
        </section>
      </main>
    </div>
  );
}
